import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { inject, observer } from "mobx-react";
import withCustomStyles from "./StickyCartBarPart.style";
import gtmService from "../services/GTMService";
import { formatItemCount, formatPrice } from "../utils/FormatUtils";
import { STANDALONE_PAGES } from "../constatns/AppConstants";

// Pages where the floating "View cart" pill is not shown: flows with their own
// bottom action, account pages and one-off utility pages.
const HIDDEN_PREFIXES = [
  ...STANDALONE_PAGES,
  "/myorders",
  "/profile",
  "/wallet",
  "/membership",
  "/add-card",
  "/saved-locations",
  "/add-address",
  "/edit-address",
  "/order/",
  "/redirect",
  "/unsubscribe",
  // content / legal pages
  "/terms",
  "/privacy",
  "/return-and-refund-policy",
  "/faqs",
  "/mobile-app"
];

export const isCartBarHidden = pathname =>
  HIDDEN_PREFIXES.some(prefix => pathname.startsWith(prefix));

// Black pill fixed to the bottom centre: "N items · View cart · Rs X".
@inject(["orderStore"])
@observer
class StickyCartBarPart extends React.Component {
  state = { bumps: 0 };

  // total units in the cart; read in render so the observer tracks it
  totalQty = () => {
    let qty = 0;
    this.props.orderStore.all.forEach(p => {
      qty += p.order_quantity || 0;
    });
    return qty;
  };

  lastQty = this.totalQty();

  componentDidUpdate() {
    const qty = this.totalQty();
    // bump only when something was added, not on removals or page loads
    if (qty > this.lastQty) {
      this.setState(({ bumps }) => ({ bumps: bumps + 1 }));
    }
    this.lastQty = qty;
  }

  handleClick = () => {
    gtmService.event(
      "User",
      "Sticky_cart_bar_clicked",
      this.props.location.pathname
    );
  };

  render() {
    const {
      classes,
      orderStore,
      location: { pathname }
    } = this.props;
    const count = orderStore.all.size;
    const { bumps } = this.state;
    this.totalQty(); // subscribe to quantity changes for componentDidUpdate

    if (!count || isCartBarHidden(pathname)) {
      return null;
    }

    return (
      <div className={classes.wrap}>
        <Link
          // a new key remounts the pill so the bump animation replays
          key={bumps}
          to="/cart"
          className={classnames(classes.bar, { [classes.bump]: bumps > 0 })}
          onClick={this.handleClick}
        >
          <span className={classes.count} aria-live="polite">
            {formatItemCount(count)}
          </span>
          <span className={classes.cta}>
            View cart · {formatPrice(orderStore.subTotal)}
          </span>
        </Link>
      </div>
    );
  }
}

export default withRouter(withCustomStyles(StickyCartBarPart));
